export default "__VITE_ASSET__E40sq2YK__"